import React ,{useEffect , useState} from "react";
import "./newsDetails.scss";
import NewsDetailsNanner from "../../../assets/images/news-details-banner.png";
import NewsDetailsNanner1 from "../../../assets/images/news-sec-banner.png";
import { useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";

export default function NewsDetails() {
const {id} =useParams<any>();

const [newsData ,setNewsData] =useState<any>([])
 console.log("paramid",newsData)
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);


 

  useEffect(()=>{
    handleNews();
  },[id])


  const handleNews= async () => {
    await axios
    .get(`https://api.deutscher.rejoicehub.com/api/v1/news/find?id=${id}`)
      .then((res : any) => {
         setNewsData(res?.data?.payload?.data);
      })
      .catch((err :any) => {
        console.log("err", err);
        
      });

  }
  return (
    <div>
      <div className="new-details-banner">
        <img src={NewsDetailsNanner} alt="NewsDetailsNanner" />
      </div>
      <div className="news-details-banner-content-alignment">
        <div className="container-lg-9">
          <div className="page-title-alignment">
            <span>{moment(newsData[0]?.updatedAt).format("DD.MM.YYYY")}</span>
            <h2>{newsData[0]?.title}</h2>
            <p>
              {newsData[0]?.description}
            </p>
            {/* <p>
              Cum recusandae suscipit et voluptas provident ut quis corrupti non
              dolor quae sit dolores vitae et voluptatem quae et ipsum numquam.
              Eos quos voluptatum et molestias quaerat ut omnis voluptates id
              dolor quasi? Qui minus maxime et atque vero qui quod eaque! Non
              tempora dicta ut perferendis quos aut facilis omnis. Et voluptates
              perspiciatis rem mollitia sint est soluta placeat At voluptas
              officia et deserunt officia est facere corporis et consequuntur
              possimus.
            </p> */}
            <img src={newsData[0]?.image} alt="deutscherImage" />
          </div>
        </div>
      </div>
    </div>
  );
}
